/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'up-arrow-error': {
    width: 10,
    height: 12,
    viewBox: '0 0 10 12',
    data: '<path pid="0" d="M9.375 5.247a.37.37 0 0 0 .265-.635L5.138.11a.37.37 0 0 0-.26-.11.37.37 0 0 0-.264.11L.112 4.612a.37.37 0 0 0 .26.635h1.952c.153 0 .276.123.276.276v6.107c0 .205.166.37.37.37H6.77a.37.37 0 0 0 .37-.37V5.523c0-.153.123-.276.276-.276h1.958" _fill="#FA5A56" fill-rule="evenodd"/>'
  }
})
